"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoRecordMessage = void 0;
const React = require("react");
const react_native_1 = require("react-native");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const layout_1 = require("../modules/layout");
const Space_1 = require("./Space");
class NoRecordMessage extends React.Component {
    constructor() {
        super(...arguments);
        this.getStyles = () => {
            return react_native_1.StyleSheet.create({
                text: {
                    fontSize: (0, layout_1.isTablet)() ? 28 : 18,
                    color: '#969696',
                    textAlign: 'center'
                },
                icon: { color: '#969696' },
                view: { alignItems: 'center', marginTop: 25 }
            });
        };
    }
    render() {
        const { visible, message } = this.props;
        if (!visible) {
            return React.createElement(React.Fragment, null);
        }
        const styles = this.getStyles();
        return (React.createElement(react_native_1.View, { style: styles.view },
            React.createElement(FontAwesome_1.default, { name: 'exclamation-triangle', size: (0, layout_1.isTablet)() ? 80 : 60, style: styles.icon }),
            React.createElement(Space_1.Space, { height: 5 }),
            React.createElement(react_native_1.Text, { style: styles.text }, message)));
    }
}
exports.NoRecordMessage = NoRecordMessage;
